import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from 'components/Box'
import Text from 'components/Text'

import { LeadChangedData, Notification } from 'types/global'

import { Highlight } from './styles'
import NotificationHeader from './NotificationHeader'
import NotificationFooter from './NotificationFooter'

type Props = Notification & {
  data: LeadChangedData
}

const LeadNameUpdate: React.FC<Props> = ({ data: { oldValue, newValue }, ...props }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" paddingLeft="10px" width="100%" flexDirection="column">
      <NotificationHeader {...props} title="lead_name_update_success" />
      <Box display="flex" paddingTop="4px">
        <Text lineHeight="22px">
          {t('lead_lbl')}
          <Highlight>{oldValue}</Highlight>
          {t('notification_lead_name_update', { newValue })}
        </Text>
      </Box>
      <NotificationFooter {...props} />
    </Box>
  )
}

export default LeadNameUpdate
